import React, { useMemo } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Button, ButtonBar } from '../../../../../common/components';
import ViewDocumentModal from '../ViewDocumentModal/ViewDocumentModal';
import { connect } from 'react-redux';
import EditDocumentModal from '../EditDocumentModal/EditDocumentModal';
import DocumentListItemContainer from '../DocumentListItemContainer/DocumentListItemContainer';
import formatSchemesByStatus from '../../../helpers/formatSchemesByStatus';
import { kebabCase } from 'lodash';

import NewDocumentModal from '../NewDocumentModal/NewDocumentModal';

const schemesForCheckbox = (schemes) => {
  if (!schemes) {
    return [];
  }
  return Object.keys(schemes).map((schemeName) => {
    const activeSchemes = schemes[schemeName];
    return {
      value: schemeName,
      label: schemeName,
      className: 'insurer checkbox-toggle-container',
      children: formatSchemesByStatus(activeSchemes, kebabCase(schemeName)),
    };
  });
};

const AncillarySchemeDocumentList = ({
  productCode,
  actionType,
  documents,
  ancillarySchemes,
  onEditDocument,
  onAddDocument,
  activeEditDocument,
  viewDocumentModal,
  documentsGenerated,
  editDocumentModal,
  activeViewDocument,
  getAncillaryFormInfo,
  ancillarySchemeDocumentType,
  onRefresh,
}) => {
  const handleRefresh = () => {
    onRefresh();
  };

  const schemes = useMemo(() => schemesForCheckbox(ancillarySchemes), [ancillarySchemes]);

  return (
    <div>
      <Row>
        {Object.keys(documents).map((documentName) => {
          const documentDetails = documents[documentName];
          return (
            <Col sm={6} key={documentName}>
              <DocumentListItemContainer
                documents={documentDetails}
                documentsGenerated={documentsGenerated || []}
              />
            </Col>
          );
        })}
      </Row>
      <Row>
        <Col sm={12}>
          <ButtonBar>
            <NewDocumentModal
              show={productCode === 'TRAV'}
              schemes={schemes}
              onAddDocument={onAddDocument}
              documentTypeId={ancillarySchemeDocumentType?.id}
              isAncillarySchemeDocument
              getAncillaryFormInfo={getAncillaryFormInfo}
            />
            <Button bsStyle={'action'} handleClick={handleRefresh}>
              Refresh
            </Button>
          </ButtonBar>
        </Col>
      </Row>
      {viewDocumentModal && (
        <ViewDocumentModal
          actionType={actionType}
          document={activeViewDocument}
          showDocumentModal={viewDocumentModal}
          isAncillaryDocument={true}
        />
      )}

      {editDocumentModal && (
        <EditDocumentModal
          actionType={actionType}
          document={activeEditDocument}
          show={editDocumentModal}
          schemes={schemes}
          onEditDocument={onEditDocument}
          onAddDocument={onAddDocument}
          isAncillarySchemeDocument
          getAncillaryFormInfo={getAncillaryFormInfo}
        />
      )}
    </div>
  );
};

export default connect(
  (state) => ({
    actionType: state.documentManagement.actionType,
    viewDocumentModal: state.documentManagement.showViewDocumentModal,
    editDocumentModal: state.documentManagement.showEditDocumentModal,
    activeViewDocument: state.documentManagement.activeViewDocument,
    activeEditDocument: state.documentManagement.activeEditDocument,
    documentsGenerated: state.documentManagement.documentsGenerated,
    ancillarySchemes: state.productManagement.ancillarySchemes,
    ancillarySchemeDocumentType: state.documentManagement.ancillarySchemeDocumentType,
  }),
  null,
)(AncillarySchemeDocumentList);
